import Navbar from "../components/Navbar";

export const EliminarCuenta = () => {
  return (
    <>
      <Navbar />
      <main className="main textos-legales">
        <div className="p-6 space-y-6 text-justify text-sm leading-relaxed max-w-3xl mx-auto">
          <h1 className="text-lg font-bold text-yellow-600">Eliminar Cuenta</h1>
          <p>
            Si deseas eliminar tu cuenta de la aplicación Isla Cristina
            Pasaporte Empleo, por favor escríbenos a ayuntamiento@islacristina.orgdesde
            la dirección de correo registrada en la app o indícanos tu DNI
            asociado. Eliminaremos tu cuenta y todos tus datos asociados en un
            plazo máximo de 10 días. Necesito otra web con este texto aunque el
            email no se cual será
          </p>
        </div>
      </main>
    </>
  );
};
